export default {
  index: {
    title: "极致游戏首页",
    componentPath: "Index"
  }
};
